export class StandortModel {
    public StandortID: number = 0;
    public DebitorID: number = 0;
    public Bezeichnung: string = "";    
    public Strasse: string = "";
    public PLZ: string = "";
    public Ort: string = "";
    public LandID : number | null=null;
}

export interface StandortModelView extends StandortModel {
     DebitorNummer?:string
     DebitorName?:string
     LandName?:string
     RoofAreaCount?:number
     SafetyPointCount?:number
     DeletedOn?: Date 
} 